export const BILLING_DEFAULT_PAGE = 1;
export const BILLING_DEFAULT_PAGE_SIZE = 10;

export const BILLING_API_BASES = {
  subscriptionPlans: "/api/v1/subscription-plans",
  coupons: "/api/v1/coupons",
  services: "/admin/services",
};

export const SUBSCRIPTION_PLAN_ENDPOINTS = {
  list: `${BILLING_API_BASES.subscriptionPlans}/plans`,
  listByService: `${BILLING_API_BASES.subscriptionPlans}/service`,
  create: BILLING_API_BASES.subscriptionPlans,
  update: BILLING_API_BASES.subscriptionPlans,
  details: (id) => `${BILLING_API_BASES.subscriptionPlans}/${id}`,
  remove: (id) => `${BILLING_API_BASES.subscriptionPlans}/${id}`,
  toggleStatus: (id, isActive) =>
    `${BILLING_API_BASES.subscriptionPlans}/${id}/status?isActive=${isActive}`,
};

export const COUPON_ENDPOINTS = {
  list: `${BILLING_API_BASES.coupons}/coupons`,
  create: BILLING_API_BASES.coupons,
  update: BILLING_API_BASES.coupons,
  detailsByCode: (couponCode) =>
    `${BILLING_API_BASES.coupons}/code/${encodeURIComponent(couponCode)}`,
  remove: (id) => `${BILLING_API_BASES.coupons}/${id}`,
  toggleStatus: (id, isActive) =>
    `${BILLING_API_BASES.coupons}/${id}/status?isActive=${isActive}`,
  validate: `${BILLING_API_BASES.coupons}/validate`,
  apply: `${BILLING_API_BASES.coupons}/apply`,
};

export const CATALOG_SERVICE_ENDPOINTS = {
  list: BILLING_API_BASES.services,
};